import { useTranslation } from "react-i18next";
import { CheckCircle } from "lucide-react";
import { QuizQuestion } from "./QuizQuestion";
import { lt } from "../localize";
import type { LessonStage } from "../types";

interface StageSummaryProps {
  stage: LessonStage;
  onQuizAnswer: (selectedIndex: number, isCorrect: boolean) => void;
}

export const StageSummary = ({ stage, onQuizAnswer }: StageSummaryProps) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="space-y-5">
      <h2 className="text-xl font-bold">{lt(stage.title, lang)}</h2>
      <p className="text-sm text-muted-foreground leading-relaxed">
        {lt(stage.content, lang)}
      </p>

      {/* Key points review */}
      {stage.keyPoints && stage.keyPoints.length > 0 && (
        <div className="glass p-4 space-y-2.5 border-l-4 border-l-primary">
          <h4 className="text-xs font-semibold uppercase text-primary tracking-wider flex items-center gap-1.5">
            <CheckCircle className="w-3.5 h-3.5" />
            {t("learn_key_points")}
          </h4>
          <ul className="space-y-2">
            {stage.keyPoints.map((point, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm">
                <span className="text-primary font-bold mt-0.5 shrink-0">✓</span>
                <span className="leading-relaxed">{lt(point, lang)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Quiz */}
      {stage.quiz && (
        <div className="pt-1">
          <QuizQuestion quiz={stage.quiz} onAnswer={onQuizAnswer} />
        </div>
      )}
    </div>
  );
};
